import { ref } from 'vue'
import { defineStore } from 'pinia'

/**
 * workspaceStore — stato della vista affiancata (/workspace).
 *
 * - `active`: pannello che riceverà la prossima voce di menu cliccata ('left' | 'right').
 * - `pendingOpen`: path da aprire nel pannello attivo; SplitWorkspace la consuma e resetta.
 * - `splitActive`: true quando SplitWorkspace è montata (usato da AppMenuItem per sapere
 *   se è in modalità workspace senza dipendere da useRoute nell'handler).
 */
export type PaneSide = 'left' | 'right'

export const useWorkspaceStore = defineStore('workspace', () => {
  const active = ref<PaneSide>('left')
  const pendingOpen = ref<string | null>(null)
  const splitActive = ref(false)

  function setActive(side: PaneSide) {
    active.value = side
  }

  function requestOpen(path: string) {
    pendingOpen.value = path
  }

  function clearPending() {
    pendingOpen.value = null
  }

  function onSplitMount() {
    splitActive.value = true
  }

  function onSplitUnmount() {
    splitActive.value = false
    active.value = 'left'
    pendingOpen.value = null
  }

  return { active, pendingOpen, splitActive, setActive, requestOpen, clearPending, onSplitMount, onSplitUnmount }
})
